var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji-smile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 22C18.1894 22 22.6665 17.5228 22.6665 12C22.6665 6.47715 18.1894 2 12.6665 2C7.14366 2 2.6665 6.47715 2.6665 12C2.6665 17.5228 7.14366 22 12.6665 22ZM10.5455 14.1213L9.83838 13.4142L8.42417 14.8284L9.13127 15.5355C11.0839 17.4882 14.2497 17.4882 16.2023 15.5355L16.9094 14.8284L15.4952 13.4142L14.7881 14.1213C13.6165 15.2929 11.7171 15.2929 10.5455 14.1213ZM11.1665 9.5C11.1665 10.3284 10.6069 11 9.9165 11C9.22615 11 8.6665 10.3284 8.6665 9.5C8.6665 8.67157 9.22615 8 9.9165 8C10.6069 8 11.1665 8.67157 11.1665 9.5ZM15.4165 11C16.1069 11 16.6665 10.3284 16.6665 9.5C16.6665 8.67157 16.1069 8 15.4165 8C14.7261 8 14.1665 8.67157 14.1665 9.5C14.1665 10.3284 14.7261 11 15.4165 11Z",
    fill: "#8C2060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmile);
export default __webpack_public_path__ + "static/media/emoji-smile.7ffafcb3bdf95a690c3633450e8323c4.svg";
export { ForwardRef as ReactComponent };